import m from "../../geodata/es2015/fijiEastHigh";
window.am4geodata_fijiEastHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/fijiEastHigh.js
// module id = null
// module chunks = 